<div class="dialog-container">

  <!-- Cabeçalho fixo: título muda conforme a tela ativa -->
  <div class="dialog-header">
    <h2 class="dialog-title">{{ tela === 'associar' ? 'Associar Lançamento' : 'Revisar Valores' }}</h2>
  </div>

  <!-- Card do extrato: fixo, igual nos dois filhos -->
  <div class="dialog-extrato">
    <div class="extrato-card mb-3">
      <div class="extrato-row">
        <span class="extrato-label">Data</span>
        <span class="extrato-value">{{ data.extrato.dataTransacao | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="extrato-row">
        <span class="extrato-label">Descrição</span>
        <span class="extrato-value">{{ data.extrato.memo || '—' }}</span>
      </div>
      <div class="extrato-row">
        <span class="extrato-label">Valor</span>
        <span class="extrato-value fw-bold"
            [class.entrada]="data.extrato.idNaturezaMovimentacao === naturezaEnum.Entrada"
            [class.saida]="data.extrato.idNaturezaMovimentacao === naturezaEnum.Saida">
            {{ data.extrato.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
            {{ totalBanco | abnt:'preco' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Conteúdo do filho ativo — [hidden] mantém estado e elimina delay -->
  <app-associar-lancamento #associarRef
    [hidden]="tela !== 'associar'"
    [extrato]="data.extrato"
    [idContaFinanceira]="data.idContaFinanceira"
    (revisarValores)="abrirRevisar($event)"
    (conciliado)="dialogRef.close(true)"
    (fechar)="dialogRef.close(false)">
  </app-associar-lancamento>

  <app-revisar-valores #revisarRef
    [hidden]="tela !== 'revisar'"
    [extrato]="data.extrato"
    [idContaFinanceira]="data.idContaFinanceira"
    [itensSelecionados]="itensSelecionadosParaRevisar"
    (conciliado)="dialogRef.close(true)"
    (voltar)="voltarParaAssociar()">
  </app-revisar-valores>

  <!-- ── Footer fixo no fundo do modal ─────────────────── -->
  <div class="dialog-footer">

    @if (tela === 'associar') {
      <!-- Totais: estado associar -->
      <div class="totais">
        <div class="footer-item">
          <span class="footer-label">Total banco</span>
          <span class="footer-value">{{ associarRef.totalBanco | abnt:'preco' }}</span>
        </div>
        <div class="footer-item">
          <span class="footer-label">Já selecionado</span>
          <span class="footer-value" [class.footer-valor-ok]="associarRef.podeConciliar">
            {{ associarRef.totalSelecionado | abnt:'preco' }}
          </span>
        </div>
        <div class="footer-item">
          <span class="footer-label">Falta conciliar</span>
          <span class="footer-value" [class.footer-valor-falta]="associarRef.faltaConciliar > 0.01">
            {{ associarRef.faltaConciliar | abnt:'preco' }}
          </span>
        </div>
      </div>
      <!-- Botões: estado associar -->
      <div class="botoes">
        <button mat-stroked-button class="btn-secondary"
          [disabled]="!associarRef.podeRevisar || associarRef.isSalvando"
          (click)="associarRef.onRevisarValores()">
          Revisar valores
        </button>
        <button mat-stroked-button class="btn-secondary" (click)="dialogRef.close(false)">Cancelar</button>
        <button mat-flat-button class="btn-primary"
          [disabled]="!associarRef.podeConciliar || associarRef.isSalvando"
          (click)="associarRef.confirmar()">
          @if (associarRef.isSalvando) {
            <mat-spinner diameter="18" class="spinner-inline"></mat-spinner>
          } @else {
            Confirmar
          }
        </button>
      </div>
    }

    @if (tela === 'revisar') {
      <!-- Totais: estado revisar -->
      <div class="totais">
        <div class="footer-item">
          <span class="footer-label">Total banco</span>
          <span class="footer-value">{{ revisarRef.totalBanco | abnt:'preco' }}</span>
        </div>
        <div class="footer-item">
          <span class="footer-label">Total ajustado</span>
          <span class="footer-value" [class.footer-valor-ok]="revisarRef.podeConciliar">
            {{ revisarRef.totalAjustado | abnt:'preco' }}
          </span>
        </div>
        <div class="footer-item">
          <span class="footer-label">Diferença</span>
          <span class="footer-value" [class.footer-valor-falta]="Math.abs(revisarRef.diferenca) >= 0.01">
            {{ revisarRef.diferenca | abnt:'preco' }}
          </span>
        </div>
      </div>
      <!-- Botões: estado revisar -->
      <div class="botoes">
        <button mat-stroked-button class="btn-secondary"
          [disabled]="revisarRef.isSalvando"
          (click)="revisarRef.onVoltar()">
          Voltar
        </button>
        <span style="display:inline-block"
              [matTooltip]="!revisarRef.podeConciliar && !revisarRef.isSalvando ? 'Corrija a diferença de ' + (revisarRef.diferenca | abnt:'preco') : ''"
              matTooltipPosition="above">
          <button mat-flat-button class="btn-primary"
            [disabled]="!revisarRef.podeConciliar || revisarRef.isSalvando"
            (click)="revisarRef.confirmar()">
            @if (revisarRef.isSalvando) {
              <mat-spinner diameter="18" class="spinner-inline"></mat-spinner>
            } @else {
              Confirmar
            }
          </button>
        </span>
      </div>
    }

  </div>

</div>
